<template>

  <div>

    <t-dialog-import type="enterprise"
                     @onImported="onDialogImported"
                     @onDuplicate="openDialogDuplicate"
                     :new-to="'place-enterprise-form-new'"/>


    <t-dialog-duplicate dialog-id="modal-duplicate-enterprise" v-if="formDuplicateShow" :origin="formDuplicate.origin"
                        path-server="place/enterprise" :form-error="formDuplicateError" v-model="formDuplicate"
                        title="Empreendimento" @onSubmit="onDuplicated">

      <template #default="{status}">

        <t-msg info>Somente a estrutura de divisões, locais e ambientes serão duplicados.</t-msg>

        <t-input-code-label required :status="status"
                            :command="'insert'" enterprise v-model="formDuplicate.enterpriseId"/>

        <t-input label="Nome do novo Empreendimento" :status="status" :add-error="formDuplicateError.name"
                 v-model="formDuplicate.changeName" required/>


        <b-form-checkbox class="col-sm-12 ml-2 mb-3" v-model="formDuplicate.enableCopyContentText" switch>
          Habilitar duplicação de textos dos conteúdos?
          <t-help
              title="Você poderá especificar se deseja copiar os dados contidos na aba 'Conteúdo'."/>
        </b-form-checkbox>

        <b-form-checkbox class="col-sm-12 ml-2 mb-3" v-if="formDuplicate.enableCopyContentText"
                         v-model="formDuplicate.enableCopyContentImage" switch>
          Habilitar duplicação das imagens dos conteúdos?
          <t-help
              title="Você poderá especificar se deseja copiar também as imagens dos conteúdos."/>
        </b-form-checkbox>


      </template>

    </t-dialog-duplicate>


    <b-modal size="xl" @hide="closeSearch()" ref="modal" no-close-on-esc :id="id"
             no-close-on-backdrop
             :title="'Buscar ' + label" hide-footer>

      <b-row>

        <t-input cols="3" v-model="form.default" :label="'Cód. '+ label + ' / Descrição'"
                 @keyup.enter.native="executeSearchInput"/>

        <t-input-code-label v-if="type === 'spotFolder' || type === 'environment' " enterprise
                            btn-search-id="btn-search-enterprise-dialog-environment"
                            :fixed="blockEnterpriseId > 0"
                            @change="executeSearchInput"
                            v-model="form.enterpriseId"/>

        <b-col cols="9" class="d-flex">


          <t-button @click="executeSearchInput" class="ml-3" primary form-inline>
            <b-icon-search class="mr-1" style="scale: 0.8"></b-icon-search>
            Filtrar
          </t-button>

          <t-button v-if="enableImportModel" @click="openDialogForm('modal-import-enterprise')" class="ml-3" form-inline>
            <b-icon-plus-circle class="mr-1" style="scale: 0.8"></b-icon-plus-circle>
            Cadastrar Novo
          </t-button>


        </b-col>


      </b-row>

      <t-msg info v-if="blockEnterpriseId > 0">Este empreendimento está bloqueado para alterações devido à consistência das informações.<br />No entanto, você ainda pode escolher o ambiente desejado.</t-msg>

      <b-row class="mb-3">

        <b-col cols="12" v-if="entityFieldCustomized('page').length > 0">

          <t-page-form-field-customized
              ref="fieldsGeneral"
              @onPressEnter="executeSearchInput"
              only-search
              big-search
              :fields-customizable="entityFieldCustomized('page')"
              :foreign-key="entityPageId" :primary-key-column="primaryKeyColumn" foreign-key-column="pageId"
          />

        </b-col>

      </b-row>

      <div style="overflow: hidden; position: relative; float: left; width: 100%">

        <t-msg info v-if="type === 'environment' && form.enterpriseId === 0">Selecione um empreendimento para listar os ambientes relacionados</t-msg>

        <t-table
            v-else
            @getPage="getPageSearchList"
            :show="checkViewListTableDefault()"
            :filtered="filtered"
            :busy="!pageListIsLoaded"
            :user-auth="userAuth"
            :items="request.content"
            :fields="viewFieldsPageRelation"
            :total-pages="request.totalPages"
            :total-elements="request.totalElements"
            :container-table-style="[{'min-height':'250px'}]"
            :title-items="titleItems"
            :link-primary-column="codeLabelKeyColumn"
            table-bordered
            table-striped
            disable-actions-column
            :primary-key-column="primaryKeyColumn">

          <template #first-column="{item}">
            <b-link @click="selectItemList(item[primaryKeyColumn])">{{ item[codeLabelKeyColumn] }}</b-link>
          </template>


        </t-table>

      </div>

    </b-modal>

  </div>

</template>
<script>
import pageInputSearchListMixin from "@/mixins/page/pageInputSearchListMixin";
import pageViewService from "@/services/modules/setting/PageView.service";

import ProductExclusiveType from "@/model/types/modules/product/ProductExclusiveType";
import TDialogDuplicate from "@/components/template/dialog/t-dialog-duplicate";
import TDialogImport from "@/components/template/dialog/t-dialog-import";

export default {
  name: 't-input-code-label-list',
  mixins: [pageInputSearchListMixin],
  components: {TDialogDuplicate, TDialogImport},
  data() {
    return {
      ProductExclusiveType,
      path: "", //Utilizando conforme vindo entityPath
      id: "modal-code-label-search",
      form: {
        default: "",
        enterpriseId: 0,
        status: 1,

      },
      viewFieldsPageRelation: [],
      fieldsCustom: [],
      fieldsCustomizable: [
        {
          entity: "page",
          foreignKeyColumn: "pageId",
          path: "",
          fields: [],
        },
      ],
      formDuplicateShow: false,
      formDuplicate: {
        enterpriseId: 0,
        origin: "",
        changeName: "",
        enableCopyContentText: true,
        enableCopyContentImage: true,
      },
      formDuplicateError: {
        name: "",
      },
    }
  },

  props: {
    entityPageId: Number,
    entityPath: String,
    codeLabelKeyColumn: String,
    primaryKeyColumn: String,
    label: String,
    blockEnterpriseId: {
      type: Number,
      default: 0
    },
    enableImportModel: Boolean,
    addSearchParamsDefault: {
      type: Array,
      default: () => [], // Usar uma função para garantir que cada instância receba um novo array
    },
    titleItems: String,
    type: {
      type: String,
      default: "",
    },
  },

  methods: {

    mountedPrepare() {

      this.searchParams.append("status","1")

      this.path = this.entityPath
      this.id += '-' + this.codeLabelKeyColumn

      if(this.addSearchParamsDefault.length > 0){

        this.addSearchParamsDefault.forEach(paramObj => {
          Object.entries(paramObj).forEach(([key, value]) => {
            this.searchParams.append(key,value)
          })
        });

      }

    },
    async mountedContinued() {

      //Campos da Listagem de Produtos (sempre pela página original, depois será verificado se há customização de campos)
      /*SEMPRE IRÁ VERIFICAR SE HOUVE OVERRIDE, POR TANTO ENVIAR A PÁGINA ORIGINAL*/
      await pageViewService.getViewFieldsByPage(this.entityPageId, true).then((response) => {
        this.viewFieldsPageRelation = response
      }).catch(error => this.responseError(error))


      await this.getFieldsCustomizableGeneralByPageId(this.entityPageId)


      if (this.type === 'environment' && this.blockEnterpriseId === 0 && (this.form.enterpriseId === 0 || this.form.enterpriseId === null)) {

        setTimeout(()=>{
          document.getElementById('btn-search-enterprise-dialog-environment')?.click()
        },200)

      }

      if(this.blockEnterpriseId > 0){
        this.form.enterpriseId = this.blockEnterpriseId
        await this.executeSearchInput()
      }

      this.pageListIsLoaded = true

    },

    async executeAfterSearch() {


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    openDialogDuplicate(enterpriseId, origin) {

      this.formDuplicateShow = true
      this.formDuplicate.enterpriseId = enterpriseId
      this.formDuplicate.origin = origin
      this.formDuplicate.changeName = ""

      this.openDialogForm('modal-duplicate-enterprise')

    },

    onDuplicated(item) {
      this.formDuplicate.changeName = ""
      this.$bvModal.hide('modal-duplicate-enterprise')
      this.selectItemList(item.enterpriseId)
    },
    onDialogImported(item) {
      this.$bvModal.hide('modal-import-models')
      this.$bvModal.hide('modal-import-enterprise')
      this.selectItemList(item.enterpriseId)
    },

    //--------------------------------------------------------------------------------------
  },


  async mounted() {

    this.mountedPrepare()

    if((this.type === 'environment' && this.form.enterpriseId > 0) || (this.type !== 'environment')){
      await this.getPageSearchList(this.pageNumber, false)
    }

    await this.mountedContinued()

  },
  watch: {
    blockEnterpriseId(val) {
      console.log('val mudado: ' + val)
      //this.form.enterpriseId = val
    }
  }
}
</script>